<template>
  <div>
    <v-toolbar
        v-if="!hideToolbar"
        :dense="!sparse"
        class="secondary-toolbar"
        flat dark bottom
    >
      <slot name="toolbar-items"></slot>
    </v-toolbar>

    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "TabItemTemplate",
  props: {
    sparse: {
      type: Boolean,
      default: false
    },
    hideToolbar: {
      type: Boolean,
      default: false
    },
  }
}
</script>

<style lang="scss" scoped>
  @import "src/theme";
</style>
